import SEO from "../../../../src/components/seo";
import Chart from "../../../../src/components/chart";
import * as React from 'react';
export default {
  SEO,
  Chart,
  React
};